export default __webpack_public_path__ + "static/media/RCSP-PREMIER.533ceb20.jpg";